import React, { Component } from "react";
import TwoColumns from "../TwoColumns/TwoColumns";
import Input from "../Input/Input";
import Button from "../Button/Button";
import "./TalentInput.css";
import { ageOptions, validEmail } from "../../config";
import classNames from 'classnames';

export default class TalentInput extends Component {

	// componentDidMount() {
	// 	console.log('t',this.props.isValid);
	// }

	componentDidUpdate() {
		// console.log('t>',this.props, this.props.isValid);
	}

	classes() {
		return classNames({
			"team-member-input": true,
			"-contracted" : !this.props.expanded,
			"-expanded" : this.props.expanded,
			"-invalid": !this.props.isValid
		});
	}

	render() {
		const {
			expanded,
			firstName,
			lastName,
			emailAddress,
			releaseForm,
			mobileNumber,
			age,
			handleInputEvent,
			removeSelf,
			toggleSelf,
			isValid
		} = this.props;
		
		if (!expanded) {
			return (
				<div
				className="talent-input -contracted"
				onClick={toggleSelf}
				>
				<div className="title">
				{(firstName || lastName) && <h3>{firstName} {lastName}</h3>}
				{(!firstName && !lastName) && <h3>New Person</h3>}
				{!isValid && <span className="tag -warning">Incomplete</span>}
				{isValid && <span className="tag -primary">Complete</span>}
				</div>
				<div className="actions">
				<Button type="small primary">
				Edit
				</Button>
				<Button type="small"
				onClick={e => {
					e.stopPropagation();
					removeSelf();
				}}
				>
				Remove
				</Button>
				</div>
				</div>
			);
		}
		
		return (
			<div className="talent-input -expanded">
			
			<div className="name">
				{(firstName || lastName) && <h3 >{firstName} {lastName}</h3>}
				{(!firstName && !lastName) && <h3 >New Person</h3>}
				{!isValid && <span className="tag -warning">Incomplete</span>}
			</div>
			
			<TwoColumns
			left={
				<div>
				<Input
				title="First Name"
				value={firstName}
				onChange={e => handleInputEvent(e, "firstName")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Last Name"
				value={lastName}
				onChange={e => handleInputEvent(e, "lastName")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Email Address"
				value={emailAddress}
				onChange={e => handleInputEvent(e, "emailAddress")}
				onBlur={this.props.handleUpdate}
				type="email"
				validate={email => validEmail.test(String(email).toLowerCase())}
				/>
				<Input
				title="Mobile Number"
				value={mobileNumber}
				onChange={e => handleInputEvent(e, "mobileNumber")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Age"
				value={age}
				type="dropdown"
				options={{
					"": "Select One",
					...ageOptions
				}}
				onChange={e => handleInputEvent(e, "age")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				</div>
			}
			right={
				<div>
				<Input
				title="Talent Release Form"
				value={releaseForm}
				type="file"
				onComplete={filename =>
					this.props.handleFileUpload(filename, "releaseForm")
				}
				filePath={`releaseforms/${this.props.entryId}/${
					this.props.talentId
				}/`}
				validate={value => value}
				/>
				<p className="-fineprint">If you haven’t got a Talent Release Form for this person, you can use these links to download one for someone <a href="https://prismic-io.s3.amazonaws.com/videosforchange%2F1d80acd6-7fd7-4f80-bc89-d4ef85f3b0ef_180705_talent+release+form+u16.pdf" target="_blank" rel="noopener noreferrer">Under 16</a> or <a href="https://prismic-io.s3.amazonaws.com/videosforchange%2F6989485c-7df4-4a44-b03d-3719255aa112_180705_talent+release+form+o16.pdf" target="_blank" rel="noopener noreferrer">Over 16</a></p>
				</div>
				
			}
			/>
			<div className="actions">
				{/* <Button type={["small"]} onClick={e => { this.props.toggleSelf }}>Close</Button> */}
				<Button type="small"
				onClick={e => {
					e.stopPropagation();
					removeSelf();
				}}
				>
				Remove This Person
				</Button>
			</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TalentInput/TalentInput.js